import Cookies from 'js-cookie';
import * as $services from '@/services/index'
import api from "../../config/api";

let _userInfo = Cookies.get('userInfo');
_userInfo = _userInfo && JSON.parse(_userInfo);
let _hospitalInfo = Cookies.get('hospitalInfo');
_hospitalInfo = _hospitalInfo && JSON.parse(_hospitalInfo);
let _platform = localStorage.getItem('CURRENT-PLATFORM'); //mp表示小程序
let _singleHospital = sessionStorage.getItem('SINGLE-HOSPITAL') || "";
let _platId = window.ServerConfig.version=='jiguan'?window.ServerConfig.platId:Cookies.get('platId')
let _openId = Cookies.get('openId');
const user = {
  state: {
    uid: Cookies.get('userId'),
    token: Cookies.get('userToken'+_platId),
    userInfo: _userInfo,
    hospitalInfo: _hospitalInfo,
    platform: _platform,
    singleHospital: _singleHospital,
    platId: _platId,
    openId:_openId
  },
  mutations: {
    setUid: (state, uid) => {
      state.uid = uid;
    },
    setToken: (state, token) => {
      state.token = token;
    },
    setUserInfo: (state, userInfo) => {
      state.userInfo = userInfo;
    },
    setHospitalInfo: (state, hospitalInfo) => {
      state.hospitalInfo = hospitalInfo;
    },
    setPlatform: (state, platform) => {
      state.platform = platform;
      localStorage.setItem('CURRENT-PLATFORM', platform);
    },
    setSingleHospital: (state, singleHospital) => {
      state.singleHospital = singleHospital;
      sessionStorage.setItem('SINGLE-HOSPITAL', singleHospital);
    },
    setPlatId: (state, platId) => {
      state.platId = platId;
      state.token = Cookies.get('userToken'+platId);
    },
    setOpenId: (state, openId) => {
      state.openId = openId;
    }
  },
  actions: {
    //登录接口: 医生
    Login({commit,state}, userInfo) {
      return new Promise((resolve, reject) => {
        $services.login(userInfo).then(res => {
          commit('setToken', res.sessionId)
          commit('setUserInfo', res)
          //设置cookie
          Cookies.set('userToken'+res.platId, res.sessionId, {expires: 7})
          Cookies.set('userId', res.user.id, {expires: 7})
          Cookies.set('userInfo', res, {expires: 7})
          resolve(res)
        }).catch(function (err) {
          reject(err)
        });
        return false;
      });
    },
    // 患者登录
    Login2({commit}, userInfo) {
      return new Promise((resolve, reject) => {
        $services.login2(userInfo).then(res => {
          commit('setToken', res.sessionId)
          commit('setUserInfo', res)
          //设置cookie
          Cookies.set('userToken'+res.platId, res.sessionId, {expires: 7})
          Cookies.set('userId', res.id, {expires: 7})
          Cookies.set('userInfo', res, {expires: 7})
          resolve(res)
        }).catch(function (err) {
          reject(err)
        });
        return false;
      });
    }
  }
};

export default user;



// WEBPACK FOOTER //
// ./src/store/modules/user.js